import axiosInstance from './axios';

export const waymarkerApi = {
    getWaymarkers: async function(stageId) {
        try {
            const params = stageId ? `?stage_id=${stageId}` : '';
            const response = await axiosInstance.get(`/waymarkers${params}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching waymarkers:', error);
            throw error;
        }
    },
    syncWaymarkers: async function() {
        try {
            await axiosInstance.get(`/waymarkers/sync`);
            return;
        } catch (error) {
            console.error('Error syncing waymarkers:', error);
            throw error;
        }
    }
};
